import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogContentText, Button } from '@mui/material';

const BlockNavigationDialog = ({ open, blocker }) => {
  return (
    <Dialog
      open={open}
      onClose={blocker.reset}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
         Υπάρχουν αλλαγές στο ticket . Αν συνεχίσετε θα χαθούν .
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={blocker.reset} color="primary">
          Πίσω
        </Button>
        <Button onClick={blocker.proceed} color="primary" autoFocus>
          Αποχώρηση
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default BlockNavigationDialog;
